/**
 * Free, confidential support lines.
 *
 * VERIFY BEFORE EVERY RELEASE: numbers and hours change. Last checked against
 * each service's own site when this list was written (2026-10). A wrong
 * number here is worse than no number, so when in doubt, remove the row and
 * let `FIND_A_HELPLINE` cover that country.
 */
export interface Helpline {
  region: string;
  name: string;
  detail: string;
  /** What the student dials or texts, as shown. */
  contact: string;
  href: string;
}

export const HELPLINES: readonly Helpline[] = [
  {
    region: 'India',
    name: 'Tele-MANAS',
    detail: 'Free, 24/7, in many languages',
    contact: '14416',
    href: 'tel:14416',
  },
  {
    region: 'India',
    name: 'iCall',
    detail: 'Mon-Sat, 10am-8pm',
    contact: '9152987821',
    href: 'tel:+919152987821',
  },
  {
    region: 'United States',
    name: '988 Suicide & Crisis Lifeline',
    detail: 'Call or text, 24/7',
    contact: '988',
    href: 'tel:988',
  },
  {
    region: 'United Kingdom',
    name: 'Samaritans',
    detail: 'Free, 24/7',
    contact: '116 123',
    href: 'tel:116123',
  },
];

/** Every other country: a directory of verified lines, by location. */
export const FIND_A_HELPLINE = 'https://findahelpline.com';
